const BASE_URL = 'https://project-final-backend.onrender.com';

export const API_URL = (slug) => `${BASE_URL}/${slug}`;